import { render, staticRenderFns } from "./AdminRole.vue?vue&type=template&id=5beb12d8&scoped=true"
import script from "./AdminRole.vue?vue&type=script&lang=js"
export * from "./AdminRole.vue?vue&type=script&lang=js"
import style0 from "./AdminRole.vue?vue&type=style&index=0&id=5beb12d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5beb12d8",
  null
  
)

export default component.exports